frappe.provide("iam.login");

iam.login.OTPHandler = class {
	constructor() {
		this.cooldownTimer = null;
	}

	onOTPSent(cooldownSeconds) {
		this.startCooldown(cooldownSeconds);
	}

	startCooldown(seconds) {
		const $resendBtn = $(".resend-otp-btn");
		if (!$resendBtn.length) return;

		let remaining = seconds;
		clearInterval(this.cooldownTimer);
		$resendBtn.prop("disabled", true);

		this.cooldownTimer = setInterval(() => {
			$resendBtn.text(__("Resend OTP in {0}s", [remaining]));
			remaining--;
			if (remaining < 0) {
				clearInterval(this.cooldownTimer);
				$resendBtn.prop("disabled", false).text(__("Resend OTP"));
			}
		}, 1000);
	}
};

function iam_bind_resend_otp() {
	$(document).off("click.iam_resend_otp", ".resend-otp-btn");
	$(document).on("click.iam_resend_otp", ".resend-otp-btn", function (e) {
		e.preventDefault();
		const credentials = iam.login.pendingCredentials;
		if (!credentials || $(this).prop("disabled")) return;

		login.call(
			{ cmd: "login", usr: credentials.usr, pwd: credentials.pwd , lang: frappe.boot?.lang || (document.documentElement.lang || "ar")},
			null,
			"/login"
		);
	});
}

function iam_patch_request_otp() {
	window.request_otp = function () {
		$(".login-content").empty();
		$(".login-content:visible").append(
			`<div id="twofactor_div">
				<form class="form-verify">
					<div class="page-card-head p-0">
						<span class="indicator blue" data-text="${__("Verification")}">${__("Verification")}</span>
					</div>
					<div id="otp_div"></div>
					<input type="text" id="login_token" autocomplete="off" class="form-control" placeholder="${__("Verification Code")}" required="">
					<button class="btn btn-sm btn-primary btn-block mt-3" type="submit" id="verify_token">${__("Verify")}</button>
					<button class="btn btn-sm btn-default btn-block mt-2 resend-otp-btn" type="button">${__("Resend OTP")}</button>
				</form>
			</div>`
		);
		verify_token();
		iam_bind_resend_otp();
		$("#login_token").get(0)?.focus();
	};
}

function iam_patch_login_handlers() {
    if (!login?.login_handlers || iam.login._handlersPatched) return;

    const originalHandler = login.login_handlers[200];
    login.login_handlers[200] = function (data) {
        if (data.verification && data.message != "Logged In") {
            const usr = ($("#login_email").val() || "").trim();
            const pwd = $("#login_password").val();
            if (usr && pwd) {
                iam.login.pendingCredentials = { usr, pwd };
            }

			if (data.verification && data.verification.prompt) {
                data.verification.prompt = __(data.verification.prompt);
            }
        }

        originalHandler(data);

        if (data.verification && data.message != "Logged In") {
            const cooldown = data.allow_send_otp_after || 60;
            iam.login.otpHandler.onOTPSent(cooldown);
        }
    };

    const originalCall = login.call;
    login.call = function (args, callback, url = "/") {
        const response = originalCall.call(this, args, callback, url);
        response?.fail?.((xhr) => {
            const message = iam.extract_server_message(xhr);
            if (!message) return;
        });
        return response;
    };

    iam.login._handlersPatched = true;
}
iam.extract_server_message = function (xhr) {
	const data = xhr.responseJSON || {};
	if (!data._server_messages) return "";

	return ($.map(JSON.parse(data._server_messages || "[]"), function (v) {
		try {
			return JSON.parse(v).message;
		} catch (e) {
			return v;
		}
	}) || []).join(" ");
};

function iam_setup_login() {
	frappe._messages = frappe._messages || {};
	if (frappe.boot && frappe.boot.__messages) {
		Object.assign(frappe._messages, frappe.boot.__messages);
	}

	if (typeof window.request_otp !== "function" || typeof window.login === "undefined") return;

	if (!iam.login.otpHandler) {
		iam.login.otpHandler = new iam.login.OTPHandler();
	}

	if (!iam.login._patched) {
		iam_patch_request_otp();
		iam.login._patched = true;
	}

	iam_patch_login_handlers();
}

$(document).on("login_rendered", iam_setup_login);
$(document).on("page-change", iam_setup_login);
setTimeout(iam_setup_login, 0);
